import React, { useState, useEffect } from 'react';

const MILO_LOGO = 'https://customer-assets.emergentagent.com/job_6ed8a1bf-8675-4ebf-8fe5-c39c1d99e001/artifacts/mu64s7zv_milo_no_bg.png';

const SplashScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [logoVisible, setLogoVisible] = useState(false);

  useEffect(() => {
    // Start logo fade-in after a small delay
    const fadeInTimer = setTimeout(() => {
      setLogoVisible(true);
    }, 100);

    // Start fade-out after 2.5 seconds
    const fadeOutTimer = setTimeout(() => {
      setFadeOut(true);
    }, 2500);

    // Complete and unmount after fade-out animation
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 3000);

    return () => {
      clearTimeout(fadeInTimer);
      clearTimeout(fadeOutTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
      style={{
        background: 'linear-gradient(180deg, #C9CDD0 0%, #F5F5F5 50%, #E0AEA3 100%)'
      }}
      data-testid="splash-screen"
    >
      {/* Milo Logo - Only element */}
      <img 
        src={MILO_LOGO} 
        alt="Milo"
        className={`w-48 h-48 md:w-56 md:h-56 object-contain transition-all duration-1000 ease-out ${
          logoVisible 
            ? 'opacity-100 transform scale-100' 
            : 'opacity-0 transform scale-95'
        }`}
        style={{
          filter: 'drop-shadow(0 8px 24px rgba(0, 0, 0, 0.1))'
        }}
      />
    </div>
  );
};

export default SplashScreen;
